import AppIcon from "./AppIcon";
export default AppIcon({ fill: "red", text: "Dm" });